<template>
    <b-table
        id="cdas"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive="sm"
        :no-local-sorting="true"
        @sort-changed="sortingChanged"
        :busy="configTable.load"
        show-empty
        > 
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Não existem cartas para serem emitidas.</p>
        </template>
        <template slot="HEAD_selecionar">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template slot="selecionar" slot-scope="row">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="row.item.checked" @change="toggleCheck($event, row.item)" />
        </template>
        <template slot="1" slot-scope="row">
            {{ row.item.numeroDivida }}
        </template>
        <template slot="2" slot-scope="row">
            {{ row.item.statusProtesto }}
        </template>
        <template slot="3" slot-scope="row">
            {{ row.item.comarca }}
        </template>
        <template slot="4" slot-scope="row">
            {{ row.item.tabelionato }}
        </template>
        <template slot="5" slot-scope="row">
            {{ row.item.protocolot32 }}
        </template>
        <template slot="6" slot-scope="row">
            {{ row.item.tipoCredito}}
        </template>
        <template slot="7" slot-scope="row">
            {{ row.item.origem }}
        </template>
        <template slot="8" slot-scope="row">
            {{ row.item.valor | currency}}
        </template>
        <template slot="9" slot-scope="row">
            {{ row.item.dataInscricao }}
        </template>
        <template slot="10" slot-scope="row">
            {{ row.item.nomeReu}}
             <template v-for="c in row.item.outrosContribuintes">
                <br :key="c.cpfCnpj" />
                {{ c.nomeReu}}
            </template>
        </template>
         <template slot="11" slot-scope="row">
            {{ row.item.numeroCpf | cpfCnpj }}
             <template v-for="c in row.item.outrosContribuintes">
                <br :key="c.cpfCnpj" />
                {{ c.numeroCpf | cpfCnpj }}
            </template>
        </template>
    </b-table>
</template>

<script>
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarCartas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el)
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item)
            } else {
                this.configTable.checkedAll = checked
                item.checked = checked
                const index = this.selecteds.indexOf(item)
                this.selecteds.splice(index, 1)
            }
        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'cda.numeroDivida'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'protesto.statusProtesto'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'protesto.comarca'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'protesto.tabelionato'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'protesto.protocolo_t32'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'cda.tipoCredito'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'cda.origem'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'cda.valorTotal'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'cda.dataInscricao'
            }
            if(ctx.sortBy == 10) {
                this.configTable.sortField = 'nomeReu'
            }
            if(ctx.sortBy == 11) {
                this.configTable.sortField = 'cpfCnpj'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        }
    }

}
</script>

<style scoped>
.no-line {
    white-space: nowrap;
}
</style>
